import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right\"><path d=\"m11.926 11.019-3.782 3.309A.69.69 0 0 1 7 13.808V7.191a.69.69 0 0 1 1.145-.52l3.78 3.309a.69.69 0 0 1 0 1.039h.001Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol